import styled from '@emotion/styled';
import {
  COLOR,
  FONT_SIZE,
  FONT_WEIGHT,
  BREAKPOINTS,
} from '@ordermentum/ui-constants';
import C from '@ordermentum/ui-constants';

export type entityType = 'retailer' | 'supplier';

const LANDING_PAGE_CTA_Z_INDEX = 3;

const entityUrl = (entityType: 'retailer' | 'supplier') =>
  `${C.IMAGE_URL}/${entityType}.jpg`;

const Card = styled('div')`
  margin: auto;
  position: relative;
`;

const EntityImage = styled('div')<{ entityType: entityType }>`
  min-height: 450px;
  width: auto;
  background-image: url(${props => entityUrl(props.entityType)});
  background-size: cover;
  display: flex;
  position: relative;
  justify-content: flex-end;
  flex-direction: column;
  background-repeat: no-repeat;
  @media (max-width: ${BREAKPOINTS.MOBILE_MAX}) {
    min-height: 300px;
  }
`;

const EntityImageContainer = styled('div')`
  display: flex;
  @media (max-width: ${BREAKPOINTS.MOBILE_MAX}) {
    flex-direction: column;
    div:not(:first-child) {
      margin-top: 2rem;
    }
  }
`;

const ButtonContainer = styled('div')<{ otherHovered: boolean }>`
  padding: 2rem;
  display: flex;
  justify-content: center;
  @media (max-width: ${BREAKPOINTS.MOBILE_MAX}) {
    padding: 0;
  }

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    opacity: ${({ otherHovered }) => (otherHovered ? 0.7 : 0)};
    background-color: black;
  }
`;

const ZIndexContainer = styled('div')`
  z-index: ${LANDING_PAGE_CTA_Z_INDEX};
`;

const ButtonText = styled('span')`
  color: ${COLOR.WHITE};
  font-size: ${FONT_SIZE.SM};
  font-weight: ${FONT_WEIGHT.MEDIUM};
  padding-left: 5rem;
  padding-right: 5rem;
  @media (max-width: ${BREAKPOINTS.MOBILE_MAX}) {
    padding-left: 2rem;
    padding-right: 2rem;
  }
`;

export {
  Card,
  EntityImage,
  EntityImageContainer,
  ButtonText,
  ButtonContainer,
  ZIndexContainer,
};
